export { default } from './ProcessingQuizStepWithRedirect';
